module.exports = __webpack_public_path__ + "e1f4d89cf55e560b7905700e4ee24b7a.png";